import React from 'react';
interface PauseIconProps extends React.SVGProps<SVGSVGElement> {
	fill?: string;
	width?: number;
	height?: number;
}

export function PauseIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<PauseIconProps>) {
	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_857_42003)" fill={fill}>
				<path d="M5 20V4a2 2 0 114 0v16a2 2 0 11-4 0zM15 20V4a2 2 0 114 0v16a2 2 0 11-4 0z" />
			</g>
			<defs>
				<clipPath id="clip0_857_42003">
					<path fill={fill} d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
